import { AppState } from 'Store'

const getAll = (state: AppState) => state.som.smsSettings.data
const getEntries = (state: AppState) => state.som.smsSettings.data.entries
const getTotal = (state: AppState) => state.som.smsSettings.data.total_entries
const getSmsStats = (state: AppState) => state.som.smsSettings.stats
const getSmsLimit = (state: AppState) => state.som.smsSettings.limit
const getParams = (state: AppState) => state.som.smsSettings.requestParams
const selectFormState = (state: AppState) => state.som.smsSettings.formState
export const smsSettingsSelector = {
	getAll,
	getEntries,
	getTotal,
	getSmsStats,
	getSmsLimit,
	getParams,
	selectFormState,
}
